var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5C4 4.94688 4.44727 4.5 5 4.5C5.55273 4.5 6 4.94688 6 5.5V11.5C6 12.0531 5.55273 12.5 5 12.5C4.44727 12.5 4 12.0531 4 11.5V5.5Z",
    fill: "#F8F8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5C7.44727 7.5 7 7.94688 7 8.5V11.5C7 12.0531 7.44727 12.5 8 12.5C8.55273 12.5 9 12.0531 9 11.5V8.5C9 7.94688 8.55273 7.5 8 7.5Z",
    fill: "#F8F8FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5C10 6.94688 10.4473 6.5 11 6.5C11.5527 6.5 12 6.94688 12 7.5V11.5C12 12.0531 11.5527 12.5 11 12.5C10.4473 12.5 10 12.0531 10 11.5V7.5Z",
    fill: "#F8F8FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.5H2C0.896484 0.5 0 1.39687 0 2.5V14.5C0 15.6031 0.896484 16.5 2 16.5H14C15.1035 16.5 16 15.6031 16 14.5V2.5C16 1.39687 15.1035 0.5 14 0.5ZM2 14.5V2.5H14V14.5H2Z",
    fill: "#F8F8FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/AnalyticsIcon.c57c3cc21dcbab38dd247604766489c4.svg";
export { ForwardRef as ReactComponent };